// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__+8Hw+"};